module.exports = __webpack_public_path__ + "img/3.39966741.jpg";